import { Container, Flex } from '@chakra-ui/react'
import { SSMLogo } from '@icon'
import { useStickyHeader } from '@lib/hooks'
import { useStore } from '@store'
import cn from 'classnames'
import { observer } from 'mobx-react-lite'
import useTranslation from 'next-translate/useTranslation'
import * as S from './styles'
import { createNavLink } from '@utils'
import { useRouter } from 'next/router'
import { IFonts } from '@interfaces'
import I18nWidget from '../I18nWidget/I18nWidget'
import SearchBox from '../../ui/SearchBox/SearchBox'
import HambugerMenu from '../../ui/HambugerMenu/HambugerMenu'
import Link from '../../ui/Link/Link'

interface IHeader {
  isHomePage?: boolean
  activeFontFamily?: IFonts
}

const Header = observer(
  ({ isHomePage, activeFontFamily = 'body' }: IHeader) => {
    const { ui, search } = useStore()
    const { t } = useTranslation()
    const { locale } = useRouter()

    // side effects
    useStickyHeader()

    const handleOnPressMenu = () => {
      ui.setDisplayBannerSlider(false)
      ui.toggleSideMenu()
    }

    const handleOnPressSearchBox = () => {
      search.toggleDisplaySearchModal()
      ui.setDisplayBannerSlider(false)
      const yCoordinate = window.pageYOffset
      window.scrollTo({ top: yCoordinate - 1, behavior: 'smooth' })
    }

    return (
      <S.Header
        display="flex"
        as="header"
        width="full"
        maxWidth="fillX"
        height="49px"
        minHeight="49px"
        zIndex={6}
        className={cn({
          'Header--sticky':
            ui.isSticky || (!isHomePage && search.displaySearchModal),
          'Header--secondary':
            (!isHomePage && !search.displaySearchModal) ||
            (isHomePage && search.displaySearchModal),
          'Header--hide':
            isHomePage && !search.displaySearchModal && !ui.isSticky
              ? false
              : ui.scrollDir === 'down',
        })}
      >
        <Container className="Header__Inner">
          <Link
            href={createNavLink('home', locale)}
            className={cn(
              {
                Header__SSMLogo: isHomePage,
              },
              {
                'Header__SSMLogo--visible':
                  isHomePage || ui.isSticky || search.displaySearchModal,
              }
            )}
          >
            <SSMLogo />
          </Link>

          <style jsx global>
            {`
              html {
                overflow-y: overlay;
              }
            `}
          </style>

          <Flex className="Header__Nav" align="center" as="nav">
            <I18nWidget
              isSticky={true}
              activeFontFamily={activeFontFamily}
            />
            <SearchBox
              onClick={handleOnPressSearchBox}
              label={t('nav:search')}
              isSticky={true}
              isActive={search.displaySearchModal}
              activeFontFamily={activeFontFamily}
            />
            <HambugerMenu
              isOpened={ui.displaySideMenu}
              onClick={handleOnPressMenu}
              label={t('nav:menu')}
              isSticky={true}
              activeFontFamily={activeFontFamily}
            />
          </Flex>
        </Container>
      </S.Header>
    )
  }
)

export default Header
